import { useEffect } from 'react';
import { useSvgModel } from '@/store/models/svg-model';
import { generateSvg } from '../utils/svg-kit';
import './index.less';

const Operate = () => {
    const svgInfo = useSvgModel((state) => state.svgConfig);
    const curShape = useSvgModel((state) => state.curShape);

    useEffect(() => {
        generateSvg(curShape, svgInfo);
    }, [svgInfo, curShape]);

    return <div className="design-svg-stage"></div>;
};
export default Operate;
